export default "__VITE_ASSET__932a889a__"